import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';

import {
  sectionUserManagement,
  sectionLicenses,
  sectionDataTypes,
  sectionSoftware,
  sectionTasks,
  sectionReports,
} from '@/components/icons/icons';

export const settingsNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Management',
    children: [
      {
        titleI18n: 'UserManagement',
        route: { name: routenames.userManagement },
        descriptionI18n: 'UserManagementDescriptionMsg',
        color: 'secondary-darken-2',
        icon: sectionUserManagement,
      },
      {
        titleI18n: 'License_other',
        route: { name: routenames.licenses },
        descriptionI18n: 'LicensesDescriptionMsg',
        color: 'secondary-darken-2',
        icon: sectionLicenses,
      },
      {
        titleI18n: 'TaskManagement',
        route: { name: routenames.protocols.index },
        descriptionI18n: 'TaskManagementDescriptionMsg',
        color: 'secondary-darken-2',
        icon: sectionTasks,
      },
      {
        titleI18n: 'QuantitiesAndUnits',
        route: { name: routenames.dataTypes },
        descriptionI18n: 'QuantitiesAndUnitsDescriptionMsg',
        color: 'secondary-darken-2',
        icon: sectionDataTypes,
      },
      {
        titleI18n: 'ReportsConfiguration',
        route: { name: routenames.reports },
        descriptionI18n: 'ReportsDescriptionMsg',
        color: 'secondary-darken-2',
        icon: sectionReports,
      },
    ],
  },
  {
    titleI18n: 'Settings',
    children: [
      {
        titleI18n: 'Settings',
        route: { name: routenames.software },
        descriptionI18n: 'SettingsDescriptionMsg',
        icon: sectionSoftware,
        color: 'secondary',
      },
    ],
  },
];
